export const TOP_DELTA_THRESHOLD = 0.2
export const BOTTOM_DELTA_THRESHOLD = 1.1
export const ROW_HEIGHT = 18
export const LIST_BOTTOM_OFFSET = ROW_HEIGHT * 4
export const BASE_OFFSET_STEP_SPEED = 5
